import styled, { css } from 'styled-components';

import colors from 'utils/colors';
import device from 'utils/device';

import { ComponentProps } from './interfaces';

export const Wrapper = styled.div<ComponentProps>`
  font-family: VIC, Verdana, Helvetica, sans-serif;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-grow: 1;
  width: 100%;
  z-index: 3;

  @media ${device.isMobile} {
    justify-content: unset;
    align-items: unset;
    display: block;
    background-color: ${colors.white};
  }

  @media ${device.isDesktop}, ${device.isTablet} {
    background-color: ${props => props.mainBackgroundColor || colors.blueGrey10};
    width: 100%;
  }
`;

export const Container = styled.div<ComponentProps>`
  display: flex;
  @media ${device.isMobile} {
    flex-direction: column;
    background-color: ${props => props.backgroundColor || colors.white};
  }

  @media ${device.isTablet} {
    width: 95vw;
    flex-direction: column;
  }

  @media ${device.isDesktop} {
    width: 960px;
    ${props => props.contentPadding && `padding: ${props.contentPadding}px`};

  }

  @media ${device.isDesktop}, ${device.isTablet} {
    ${({ hasTitle }) =>
      hasTitle
        ? css`
      transform: translateY(-120px);
      `
        : css`
        border-top: 1px solid  ${colors.darkGrey10};
        `}
    background-color: ${props => props.backgroundColor || colors.white};
    ${props => props.showLoading && 'display: flex'};
    min-height: 500px;
  }
`;
